import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => {
    const perms = user?.permissions || [];
    return {
      user,
      refresh,
      setUser,
      can: (...p) => !!user && p.some((x) => perms.includes(x)),
      impersonating: !!user?.impersonator,
      readOnly: !!user?.impersonator,
      async startImpersonation(userId) {
        const { data } = await api.post("/auth/impersonate", { user_id: userId });
        await refresh();
        return data.target;
      },
      async stopImpersonation() {
        await api.post("/auth/stop-impersonation");
        await refresh();
      },
      async logout() {
        try {
          await api.post("/auth/logout");
        } catch {
          /* ignore */
        }
        setUser(false);
      },
    };
  }, [user, refresh]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
